import { useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { restoreSession } from '../api/client';
import { useAuth } from '../stores/auth';

export function RequireAuth({ children }: { children: React.ReactNode }) {
  const { accessToken } = useAuth();
  const location = useLocation();
  const [restoreError, setRestoreError] = useState(false);
  const [attempt, setAttempt] = useState(0);
  const [restoring, setRestoring] = useState(!accessToken);

  useEffect(() => {
    if (accessToken) {
      setRestoring(false);
      return;
    }

    let active = true;
    setRestoring(true);
    setRestoreError(false);
    void restoreSession()
      .catch(() => {
        if (active) setRestoreError(true);
      })
      .then(() => {
        if (active) setRestoring(false);
      });
    return () => {
      active = false;
    };
  }, [accessToken, attempt]);

  if (!accessToken && restoring) {
    return (
      <div className="grid min-h-dvh place-items-center bg-ink-900 px-4 text-sm text-ink-400">
        Restoring your session…
      </div>
    );
  }
  if (!accessToken && restoreError) {
    return (
      <div className="grid min-h-dvh place-items-center bg-ink-900 px-4 text-sm text-ink-300">
        <div className="space-y-4 text-center" role="alert">
          <p>Could not reconnect to your session. Check your connection and retry.</p>
          <button className="btn-ghost" onClick={() => setAttempt((value) => value + 1)}>Retry connection</button>
        </div>
      </div>
    );
  }
  if (!accessToken) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }
  return <>{children}</>;
}
